import { isAfter, isBefore, parseISO } from "date-fns";
import { useContext } from "react";

import dateIntervalContext from "./dateIntervalContext";

const numericCompare = (a, b) => Number(a) - Number(b);

export default function useDateIntervalContext() {
  let { startDate, endDate } = useContext(dateIntervalContext);
  startDate = startDate && parseISO(startDate.toString());
  endDate = endDate && parseISO(endDate.toString());

  function getDatesInInterval(dates) {
    dates = dates && dates.filter(Boolean);
    if (!dates?.length) {
      return [];
    }
    dates = dates.map((date) => parseISO(date.toString()));
    if (startDate) {
      dates = dates.filter((date) => !isBefore(date, startDate));
    }
    if (endDate) {
      dates = dates.filter((date) => !isAfter(date, endDate));
    }
    dates.sort(numericCompare);
    return dates;
  }

  function getMostRelevantDate(dates) {
    dates = getDatesInInterval(dates);
    if (!dates?.length) {
      return;
    }
    // First look at upcoming dates and pick the first one
    let upcomingDates = dates.filter((date) => !isBefore(date, new Date()));
    if (upcomingDates.length) {
      return upcomingDates[0];
    }
    // Then look at past dates and pick the most recent one
    let pastDates = dates.filter((date) => !isAfter(date, new Date()));
    return pastDates[pastDates.length - 1];
  }

  return { startDate, endDate, getMostRelevantDate };
}
